/**
 * Enum containing the different workflows for ICFs
 */
enum ICFWorkflow {
  HARDCOPY = 'HARDCOPY',
  ECONSENT = 'ECONSENT',
}

export default ICFWorkflow;
